import CustomTablePagination from 'Components/CustomTablePagination'
import EnhancedTableHead, { type HeadCell } from 'Components/EnhancedTableHead/EnhancedTableHead'
import NoWrapTableCell from 'Components/NoWrapTableCell'
import StyledLink from 'Components/StyledLink'
import StyledTableRow from 'Components/StyledTableRow'
import { WithLoader } from 'Components/WithLoader'
import type {
  ZoneInfoParamShape,
  ZoneInfoShape
} from 'Services/SalesManagement/Features/ZoneInfo/zoneInfoSlice'
import { ROWS_PER_PAGE_DEFAULT, SALES_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { datetimeFormatter } from 'Util/formatters'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import type React from 'react'
import type { FC } from 'react'
import { t } from 'ttag'

const ZoneInfoList: FC<{
  rows: ZoneInfoShape[]
  loading: string
  params: ZoneInfoParamShape
  handleRequestSort: (event: React.MouseEvent<unknown>, property: string) => void
  handleChangePage: (event: unknown, newPage: number) => void
  count: number
}> = ({ rows, loading, params, handleRequestSort, handleChangePage, count }) => {
  const headCells: HeadCell[] = [
    {
      id: 'created',
      numeric: false,
      disablePadding: false,
      label: t`Created`,
      sortable: true
    },
    {
      id: 'modified',
      numeric: false,
      disablePadding: false,
      label: t`Modified`,
      sortable: false
    },
    {
      id: 'authority_code',
      numeric: false,
      disablePadding: false,
      label: t`Authority`,
      sortable: false
    }
  ]

  return (
    <WithLoader loading={loading === 'pending'} rows={ROWS_PER_PAGE_DEFAULT} height={33}>
      <Paper sx={{ width: '100%', mb: 2 }}>
        <TableContainer>
          <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size="small">
            <EnhancedTableHead
              orderBy={params.ordering}
              headCells={headCells}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {rows.map(row => {
                return (
                  <StyledTableRow hover tabIndex={-1} key={row.id}>
                    <NoWrapTableCell
                      title={datetimeFormatter(row.created)}
                      component="th"
                      scope="row"
                    >
                      <StyledLink
                        to={`${SALES_MANAGEMENT_ROOT_URL}/zone-infos/${row.authority_code}/`}
                      >
                        {datetimeFormatter(row.created)}
                      </StyledLink>
                    </NoWrapTableCell>
                    <NoWrapTableCell title={datetimeFormatter(row.modified)}>
                      {datetimeFormatter(row.modified)}
                    </NoWrapTableCell>
                    <NoWrapTableCell
                      title={`${row.authority_name} (${row.authority_code})`}
                    >{`${row.authority_name} (${row.authority_code})`}</NoWrapTableCell>
                  </StyledTableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <CustomTablePagination
          count={count}
          page={params.page - 1}
          onPageChange={handleChangePage}
        />
      </Paper>
    </WithLoader>
  )
}

export { ZoneInfoList }
